import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

const NO_REFRESH = ['/auth/login', '/auth/refresh', '/auth/logout'];
let refreshing = null;

const refreshSession = () => {
  if (!refreshing) {
    refreshing = axios.post(`${API}/auth/refresh`).finally(() => { refreshing = null; });
  }
  return refreshing;
};

axios.interceptors.response.use(null, async (error) => {
  const original = error.config;
  const url = original?.url || '';
  const skip = !original || original._retry || NO_REFRESH.some((p) => url.includes(p));
  if (error.response?.status !== 401 || skip) throw error;
  original._retry = true;
  try {
    await refreshSession();
  } catch {
    window.dispatchEvent(new Event('auth:expired'));
    throw error;
  }
  return axios(original);
});

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Algo deu errado. Tente novamente.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  }
  if (typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};
